export default __webpack_public_path__ + "static/media/logo.2079eb05.png";